module.exports = __webpack_public_path__ + "static/media/400176_01.080218f4.png";